import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { UnauthenticatedRoutes } from '@/router/routes';

export const EmailSentMessage: React.FC = () => {
  const { t } = useTranslation('unauthenticated.resetPassword');
  const navigate = useNavigate();

  return (
    <div className="w-full max-w-sm">
      <h1 className="mb-2 text-2xl font-semibold text-foreground">{t('emailSentHeader')}</h1>
      <p className="mb-6 whitespace-pre-line text-sm text-muted-foreground">
        {t('emailSentSubtitle')}
      </p>
      <Button variant="outline" onClick={() => navigate(UnauthenticatedRoutes.Login)}>
        {t('backToLogin')}
      </Button>
    </div>
  );
};
